import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_312: DocMigration = {
  maxSchemaVersion: "0.0.312",
  description: "Update option sets and options with renamed properties and switch from param_ prefix to optionSet_.",
  apply(json: any) {
    // track updated optionSet ids for FORUMULA references
    const updatedOptionSets: { [k: string]: string } = {};
    const updateFormulaObjects = (obj: any) => {
      // must account for all 'FORMULA' objects to be safe
      for (const key in obj) {
        const val = obj[key];
        if (val && typeof val === "object") {
          if (val.type === "FORMULA" && val.formula) {
            // update formula with new optionSet ids
            let formula = val.formula;
            for (const oldId in updatedOptionSets) {
              const newId = updatedOptionSets[oldId];
              formula = formula.replaceAll(oldId, newId);
            }
            val.formula = formula;
          } else {
            // recurse through object
            updateFormulaObjects(val);
          }
        }
      }
    };

    if (json.optionSets) {
      for (const optionSetId in json.optionSets) {
        const optionSet = json.optionSets[optionSetId];

        updateOptionProps(optionSet.options);

        updateOptionSetProps(optionSet);
      }

      // migrate all prefixed optionSet ids
      for (const key in json.optionSets) {
        if (key.startsWith("param_")) {
          const newKey = key.replace("param_", "optionSet_");
          // track updated optionSet ids for FORUMULA references
          updatedOptionSets[key] = newKey;
          json.optionSets[newKey] = { ...json.optionSets[key], id: newKey };
          // remove old key
          delete json.optionSets[key];
        }
      }
    }

    const oldKeys = Object.keys(updatedOptionSets);
    if (oldKeys.length > 0) {
      // Only do this if we have keys to update!
      // Updating all references to the old optionSet ids

      // First: switch all FORUMULA references to updated optionSet ids
      updateFormulaObjects(json);

      // update any active optionChoices
      for (const optionSetId in json.optionChoices) {
        if (oldKeys.includes(optionSetId)) {
          const newKey = updatedOptionSets[optionSetId];
          json.optionChoices[newKey] = json.optionChoices[optionSetId];
          delete json.optionChoices[optionSetId];
        }
      }
      // update presets
      for (const presetId in json.presets) {
        const preset = json.presets[presetId];
        for (const optionSetId in preset.optionChoices) {
          if (oldKeys.includes(optionSetId)) {
            const newKey = updatedOptionSets[optionSetId];
            preset.optionChoices[newKey] = preset.optionChoices[optionSetId];
            delete preset.optionChoices[optionSetId];
          }
        }
      }
      // update auxOptionSets
      for (const optionSetId in json.auxOptionSets) {
        if (oldKeys.includes(optionSetId)) {
          const newKey = updatedOptionSets[optionSetId];
          json.auxOptionSets[newKey] = json.auxOptionSets[optionSetId];
          if (json.auxOptionSets[newKey].id !== undefined) {
            json.auxOptionSets[newKey].id = newKey;
          }
          delete json.auxOptionSets[optionSetId];
        }
      }
      // update optionSetOverrides
      for (const overrideId in json.optionSetOverrides) {
        const override = json.optionSetOverrides[overrideId];
        if (oldKeys.includes(override.optionSetId)) {
          const oldId = override.optionSetId;
          override.optionSetId = updatedOptionSets[oldId];

          updateOptionProps(override.options);
          updateOptionSetProps(override);
        }
      }
      // update optionEffects
      for (const effectId in json.optionEffects) {
        const effect = json.optionEffects[effectId];
        if (effect && oldKeys.includes(effect.optionSetId)) {
          effect.optionSetId = updatedOptionSets[effect.optionSetId];
        }
      }
    }

    // reset optionSetRefs and builderRefs
    json.optionSetRefs = {};
    json.builderRefs = {};

    return json;
  },
};

function updateOptionSetProps(optionSet: any) {
  // migrate builderOptionSetId to builderOptionSetCode
  if (optionSet.builderOptionSetId !== undefined) {
    optionSet.builderOptionSetCode = optionSet.builderOptionSetId;
    delete optionSet.builderOptionSetId;
  }
  // migrate shortDescription to description
  if (optionSet.shortDescription !== undefined) {
    optionSet.description = optionSet.shortDescription;
    delete optionSet.shortDescription;
  }
}

function updateOptionProps(options: any) {
  // migrate all options
  for (const key in options) {
    const option = options[key];
    // migrate builderOptionId to builderOptionSetCode
    if (option.builderOptionId !== undefined) {
      option.builderOptionCode = option.builderOptionId;
      delete option.builderOptionId;
    }
    // migrate shortDescription to description
    if (option.shortDescription !== undefined) {
      option.description = option.shortDescription;
      delete option.shortDescription;
    }
    // migrate param_ prefix to optionSet_ prefix
    if (option.parentId?.startsWith("param_")) {
      option.parentId = option.parentId.replace("param_", "optionSet_");
    }
  }
}

export default migration_0_0_312;
